import { ReactElement } from "react";
import { useDropzone } from "react-dropzone";
import { infoIcon } from "../../../components/Icons";
import FileDetail from "./FileDetail";
import * as styles from "./FilesUploader.module.scss";

interface IFilesUploaderProps {
    label: string;
    placeholder: string;
    removeAllText: string;
    maxSize: number;
    maxFiles: number;
    files: File[];
    onFileAdded: (files: File[]) => void;
    onRemoveFile: (file: File) => void;
    onRemoveAll: () => void;
    tooltip: string;
}

export default function FilesUploader(props: IFilesUploaderProps): ReactElement {
    const disabled = props.files.length >= props.maxFiles;
    const { getRootProps, getInputProps } = useDropzone({ onDrop: handleOnDrop, maxSize: props.maxSize, maxFiles: props.maxFiles, disabled });

    function handleOnDrop(files: File[]) {
        if (files.length + props.files.length > props.maxFiles) return;
        props.onFileAdded(files);
    }

    return (
        <>
            <span className={styles.filesLabel}>{props.label}</span>
            <div className={styles.inputContainer}>
                <div {...getRootProps({ className: disabled ? styles.inputFileDisabled : styles.rootProps })}>
                    <input {...getInputProps()} disabled={disabled} />
                    <div dangerouslySetInnerHTML={{ __html: props.placeholder }} />
                </div>
                <div className={styles.infoIcon}>
                    {infoIcon}
                    <div className={styles.tooltip} dangerouslySetInnerHTML={{ __html: props.tooltip }} />
                </div>
            </div>
            <div>
                {props.files.map((x, i) => (
                    <FileDetail key={i} file={x} onRemoveFile={props.onRemoveFile} />
                ))}
            </div>
            <button onClick={props.onRemoveAll} type="button" className={styles.removeAll} disabled={props.files.length === 0}>
                {props.removeAllText}
            </button>
        </>
    );
}
